/**
 * ModalFooter.jsx
 *
 * @Author: jruif
 * @Date: 2017/7/7 下午10:02
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
/**
 * @ignore
 * */
const ModalFooter = ({ prefixCls, className, children }) => {
  const classes = classNames(`${prefixCls}-footer`, className);
  return <div className={classes}>{children}</div>;
};

ModalFooter.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

ModalFooter.defaultProps = {
  prefixCls: 'ne-modal',
};

export default ModalFooter;



// WEBPACK FOOTER //
// ./src/modal/ModalFooter.jsx